<template>
  <div class="detail-blocks">
    <div class="detail-blocks_title">
      <Text
        pattern="body2"
        class="detail-blocks_title-text"
        :weight="600"
        color="#787878"
      >
        {{ $t("explorer.instant_link.details_block_title") }}
      </Text>
    </div>
    <div class="detail-blocks_content">
      <div class="detail-blocks_header">
        <template v-if="input">
          <AddressBlock
            :isAddress="false"
            :title="`${$t('Input')} 1`"
            :address="input.address"
            :network="network"
            :amount="input.amount"
            :symbol="input.symbol"
            :formattedFiat="input.formattedFiat"
            :amountTransferred="input"
            type="input"
          />
        </template>
      </div>
      <div v-if="output" class="detail-blocks_column">
        <AddressBlock
          :title="`${$t('Output')} 1`"
          :address="output.address"
          :amount="output.amount"
          :symbol="output.symbol"
          :network="network"
          :formattedFiat="output.formattedFiat"
          :amountTransferred="output"
          direction="out"
          type="output"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { Text } from "@/shared/ui";
import AddressBlock from "@/features/TransactionDetails/Common/ui/AddressBlock.vue";
import "@/assets/icons/SVG/arrow-right-simple.svg";
import "@/assets/icons/SVG/coinbase-logo.svg";

export default {
  name: "InstantLinkBtcDetails",
  components: {
    Text,
    AddressBlock,
  },
  data() {
    return {
      showAll: false,
    };
  },
  props: {
    input: {
      type: Object,
      required: true,
      default: () => {},
    },
    output: {
      type: Object,
      required: true,
      default: () => {},
    },
    network: {
      type: String,
      required: true,
    },
    totalInput: {
      type: Object,
      default: null,
    },
    totalOutput: {
      type: Object,
      default: null,
    },
    fee: {
      type: Object,
      default: null,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    toggleShowAll() {
      this.showAll = !this.showAll;
    },
  },
};
</script>

<style lang="scss" scoped>
/* Renamed main class and restored original styles */
.detail-blocks {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 100%;
  border-radius: 10px;
  border: 1px solid var(--Dark-850, #1a1a1a);
  background: var(--Dark-900, #111);
  padding: 32px;

  &_title {
    padding-bottom: 10px;
    margin-bottom: 16px;
    border-bottom: 1px solid var(--Dark-850, #1a1a1a);

    &-text {
      font-size: 16px !important;
      color: #fafafa !important;
      line-height: 150% !important;
    }
  }

  &_content {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 24px;
    border-bottom: 1px solid var(--Dark-850, #1a1a1a);
    padding-bottom: 24px;

    @media (max-width: 768px) {
      grid-template-columns: 1fr;
    }
  }

  &_column {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  &_header {
    display: flex;
    flex-direction: column;
    gap: 16px;

    @media (max-width: 768px) {
      gap: 10px;
    }
  }

  .show-more {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 7px;
    padding-top: 24px;
    background: none;
    border: none;
    color: inherit;
    cursor: pointer;
    font-size: inherit; // Ensure text size matches surrounding text
  }

  .arrow {
    transition: transform 0.3s ease;
    transform: rotate(90deg);
    width: 16px;
    height: 16px;

    &.rotate-up {
      transform: rotate(-90deg);
    }
  }

  .coinbase-card {
    display: flex;
    align-items: center;
    gap: 13px;
    border-radius: 10px;
    border: 1px solid var(--Dark-850, #1a1a1a);
    padding: 27px 24px; // Размерность как у блоков output
  }
}
</style>
